import { render, staticRenderFns } from "./ClientProjectsEditProposalsList.vue?vue&type=template&id=36028d9c&"
import script from "./ClientProjectsEditProposalsList.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsEditProposalsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports